module.exports = __webpack_public_path__ + "static/img/monkey.813920d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/monkey.jpg
// module id = 0sky
// module chunks = 1